module.exports = __webpack_public_path__ + "img/binder_feeder.5b152b49.svg";